module.exports = __webpack_public_path__ + "static/img/1.b5a6e69.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/19/zh/1.png
// module id = qTCo
// module chunks = 0